<template>
    <div class="dot-navigation-container flex gap-2px justify-center" data-cy="list_dot_navigation">
        <div
            v-for="i in total"
            :key="`dot-nav-${i}`"
            class="inline-flex dot-nav h-1 rounded-full transition-width"
            :class="[isActive(i) ? 'bg-dark-6 w-4' : 'bg-gold w-1']"
            :data-cy="`card_dot_navigation_dot_${i}`"
        ></div>
    </div>
</template>
<script>
// active = bg-dark-6
// inactive = gold
export default {
    name: 'DotNavigation',
    props: {
        modelValue: { // zero-based
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true,
        }
    },
    emits: ["update:modelValue"],
    data: function () { return {} },
    computed: {
        value: {
            get: function () {
                return this.modelValue
            },
            set: function (val) {
                this.$emit("update:modelValue", val)
            }
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        isActive: function (i) {
            return this.value == (i - 1)
        }
    }
}
</script>
